import { useCallback, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Input, Picker, Popup } from 'react-vant';
import AppBar from '../components/appBar';
import Page from '../components/page';
import AddressParse from 'address-parse';
import { areaList, cityList, cloneDeep, parseLocationParams, provinceList, showToast } from '../utils/utils';
import { apiGetH5GetOrderAddress, apiH5EditOrderAddress } from '../api';
import Loading from '../components/loading';

interface Address {
  id?: string;
  address?: string;
  city?: string;
  county?: string;
  province?: string;
  receiverName?: string;
  receiverPhone?: string;
}

export default function ChangeAddressPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const [detailData, setdetailData] = useState<Address>();
  const [loading, setloading] = useState<boolean>(false);
  const [message, setmessage] = useState<string>();
  const [locationType, setLocationType] = useState<string>();
  const [locationVal, setLocationVal] = useState<string>();
  const [locationData, setlocationData] = useState<string[]>([]);

  useEffect(() => {
    let _p = parseLocationParams(location.search) ?? {};
    if (_p.id) {
      getH5GetOrderAddress(_p.id);
    }
  }, []); // eslint-disable-line

  async function getH5GetOrderAddress(id: string) {
    let res = await apiGetH5GetOrderAddress({ id });
    let data = res.data;
    if (data.code === 200) {
      setdetailData(data?.data);
    }
  }

  // 任意字段修改时存入编辑数据
  function handleChange(
    key: string,
    value: any,
    secondKey?: string,
    secondValue?: any,
    thirdKey?: string,
    thirdValue?: any
  ) {
    let data: any = cloneDeep(detailData);
    data[key] = value;
    if (secondKey) {
      data[secondKey] = secondValue;
    }
    if (thirdKey) {
      data[thirdKey] = thirdValue;
    }
    setdetailData(data);
  }

  // 获取剪切板内容（兼容现代浏览器+旧浏览器）
  const getClipboardContent = useCallback(async () => {
    try {
      let text = '';

      // 方案1：现代浏览器（推荐）- Clipboard API（仅读取文本）
      if (navigator.clipboard && typeof navigator.clipboard.readText === 'function') {
        text = await navigator.clipboard.readText();
        // 校验是否为有效文本（过滤纯空白内容）
        if (!text.trim()) {
          throw new Error('剪切板中无有效文字内容');
        }
      }
      // 方案2：降级兼容（旧浏览器）- 仅处理文本粘贴
      else {
        const textarea = document.createElement('textarea');
        // 隐藏临时文本框（不影响页面布局）
        textarea.style.cssText = 'position: fixed; top: -999px; left: -999px; opacity: 0;';
        document.body.appendChild(textarea);

        // 聚焦并执行粘贴（仅能粘贴文本）
        textarea.focus();
        const pasteSuccess = document.execCommand('paste');
        if (!pasteSuccess) {
          throw new Error('浏览器不支持粘贴操作，请手动输入');
        }

        text = textarea.value.trim();
        document.body.removeChild(textarea);

        // 校验文本有效性
        if (!text) {
          throw new Error('剪切板中无有效文字内容');
        }
      }

      // 存储剪切板内容，更新状态
      setmessage(text);
      parseAddress(text);
    } catch (err) {
      // 捕获异常（如用户拒绝权限、浏览器不支持）
      const error = err as Error;
      showToast(error.message || '获取剪切板内容失败，请检查权限或浏览器兼容性');
    }
  }, []); // eslint-disable-line

  // 智能识别
  const parseAddress = (content?: string) => {
    let val = !!content ? content : message;
    if (!!val) {
      const result: any = AddressParse.parse(val);
      let list = result[0];
      console.log('----', list);
      let obj = {
        receiverName: list?.name,
        receiverPhone: list?.mobile,
        province: list?.province,
        city: list?.city,
        county: list?.area,
        address: list?.details,
      };
      let _data = Object.assign({}, detailData, obj);
      setdetailData(_data);
      console.log('----', _data);
    } else {
      showToast('请输入要识别的信息');
    }
  };

  function handleChangeArea(type: string) {
    if (type === 'province') {
      setLocationType(type);
      setLocationVal(detailData?.province);
      setlocationData(provinceList(false));
    } else if (type === 'city') {
      if (!detailData?.province) return showToast('请先选择省');
      setLocationType(type);
      setLocationVal(detailData?.city);
      setlocationData(cityList(detailData?.province));
    } else if (type === 'county') {
      if (!detailData?.province) {
        showToast('请先选择省');
        return;
      } else if (!detailData?.city) {
        showToast('请先选择市');
        return;
      }
      setLocationType(type);
      setLocationVal(detailData?.county);
      setlocationData(areaList(detailData?.province, detailData?.city));
    }
  }

  function changeAddress(value: string) {
    if (locationType === 'province') {
      handleChange('province', value, 'city', '', 'county', '');
    } else if (locationType === 'city') {
      handleChange('city', value, 'county', '');
    } else if (locationType === 'county') {
      handleChange('county', value);
    }
  }
  function verifyAddress() {
    let msg = '';
    let telReg = /^1[3-9]{1}[0-9]{9}$/;
    if (!detailData?.receiverName) {
      msg = '请填写收件人姓名';
    } else if (!detailData?.receiverPhone) {
      msg = '请填写收件人手机号';
    } else if (!telReg.test(detailData?.receiverPhone)) {
      msg = '请填写正确的收件人手机号';
    } else if (!detailData?.province) {
      msg = '请选择省';
    } else if (!detailData?.city) {
      msg = '请选择市';
    } else if (!detailData?.county) {
      msg = '请选择区';
    } else if (!detailData?.address) {
      msg = '请填写详细地址';
    }
    if (!!msg) {
      showToast(msg);
      return false;
    }
    return true;
  }

  async function handleSubmit() {
    if (!verifyAddress()) return;
    setloading(true);

    try {
      let res = await apiH5EditOrderAddress({ ...detailData });
      let data = res.data;
      if (data.code === 200) {
        showToast(data?.msg ?? '操作成功');
        navigate(-1);
      } else {
        showToast(data?.msg ?? '操作失败');
      }
    } catch (e) {
    } finally {
      setloading(false);
    }
  }

  return (
    <Page
      className="changeaddress-page d-flex-c"
      contentClassName="flex-1 h-1 mb-10 overflow-y"
      appBar={<AppBar className="bg-transparent" title="修改地址" />}
    >
      <div className="m-15 bg-white border-radius-8 p-15 d-flex-c">
        <div className="bg-gray border-radius-8 p-10 d-flex-r ai-center">
          <Input.TextArea
            className="flex-1"
            value={message}
            onChange={(v) => setmessage(v)}
            placeholder="粘贴文本后将自动识别地址信息"
            autoSize={{ minHeight: 60, maxHeight: 70 }}
            // onBlur={() => (!!message ? parseAddress() : '')}
          />
          <div
            className="parseaddress-btn ml-12 text-color-p p-5 pl-8 pr-8 bg-white"
            onClick={() => {
              !message ? getClipboardContent() : parseAddress();
            }}
          >
            {!!message ? '识别' : '粘贴并识别'}
          </div>
        </div>
        <div className="mt-20 d-flex-r ai-center jc-between">
          <div className="w-100 text-color-6">收货人</div>
          <Input
            className="input-line"
            placeholder="请输入收货人姓名"
            value={detailData?.receiverName}
            onChange={(v) => handleChange('receiverName', v)}
          />
        </div>
        <div className="mt-20 d-flex-r ai-center jc-between">
          <div className="w-100 text-color-6">手机号</div>
          <Input
            className="input-line"
            placeholder="请输入收货人手机号"
            value={detailData?.receiverPhone}
            onChange={(v) => handleChange('receiverPhone', v)}
          />
        </div>
        <div className="mt-20 d-flex-r ai-center jc-between">
          <div className="w-100 text-color-6">选择省</div>
          <div className="d-flex-r ai-center jc-end" onClick={() => handleChangeArea('province')}>
            {detailData?.province ? detailData?.province : <span className="placeholder">请选择</span>}
            <img className="w-15" src="/pic/icon_refund_right_9.png" alt="" />
          </div>
        </div>
        <div className="mt-20 d-flex-r ai-center jc-between">
          <div className="w-100 text-color-6">选择市</div>
          <div className="d-flex-r ai-center jc-end" onClick={() => handleChangeArea('city')}>
            {detailData?.city ? detailData?.city : <span className="placeholder">请选择</span>}
            <img className="w-15" src="/pic/icon_refund_right_9.png" alt="" />
          </div>
        </div>
        <div className="mt-20 d-flex-r ai-center jc-between">
          <div className="w-100 text-color-6">选择区</div>
          <div className="d-flex-r ai-center jc-end" onClick={() => handleChangeArea('county')}>
            {detailData?.county ? detailData?.county : <span className="placeholder">请选择</span>}
            <img className="w-15" src="/pic/icon_refund_right_9.png" alt="" />
          </div>
        </div>
        <div className="mt-20 d-flex-r ai-start jc-between">
          <div className="w-100 text-color-6">详细地址</div>
          <Input.TextArea
            className="input-line"
            placeholder="请输入详细地址"
            value={detailData?.address}
            onChange={(v) => handleChange('address', v)}
          />
        </div>
      </div>
      <div
        className="ml-10 mr-10 mt-20 mb-30 bg-p pt-15 pb-15 border-radius-30 text-color-white text-center"
        onClick={handleSubmit}
      >
        提交地址
      </div>
      <Popup position="bottom" visible={!!locationType}>
        <Picker
          title="请选择"
          columns={locationData}
          value={locationVal}
          onCancel={() => {
            setLocationType(undefined);
            setLocationVal(undefined);
            setlocationData([]);
          }}
          onConfirm={(v: string) => {
            setLocationType(undefined);
            changeAddress(v);
          }}
        />
      </Popup>

      {loading && (
        <Loading
          tips={'正在加载中...'}
          loadingClass="bh-100 overflow-hidden text-color-white d-flex-r ai-center jc-center mt-0 bg-shallow"
        />
      )}
    </Page>
  );
}
